import {
  DatagridConfigurable,
  List,
  TextField,
  TopToolbar,
  SelectColumnsButton,
  CreateButton,
  SearchInput,
} from "react-admin";

import { CLIENT_SEARCH_SOURCE } from "@/constants/filters";

const ListActions = () => (
  <TopToolbar>
    <SelectColumnsButton />
    <CreateButton />
  </TopToolbar>
);

export const TrafficSourcesList = () => (
  <List
    actions={<ListActions />}
    filters={[
      <SearchInput
        key="search"
        source={CLIENT_SEARCH_SOURCE}
        placeholder="Search Traffic Source"
        alwaysOn
      />,
    ]}
    sort={{ field: "title", order: "ASC" }}
    pagination={false}
    storeKey={false}
  >
    <DatagridConfigurable
      bulkActionButtons={false}
      omit={["createdAt", "updatedAt"]}
    >
      <TextField source="title" />
      <TextField label="Max Click Id Length" source="maxClickIdLength" />
      <TextField source="createdAt" />
      <TextField source="updatedAt" />
    </DatagridConfigurable>
  </List>
);
